import clsx from 'clsx';
import React from 'react';
import { SignupStepActions } from './SignupStepActions';
import { SignupStepFooter } from './SignupStepFooter';

type ContentVariant = 'default' | 'narrow' | 'compact' | 'spacious';

const contentVariantStyles: Record<ContentVariant, string> = {
  default: '',
  narrow: 'px-4 sm:px-[200px] py-2.5',
  compact: 'px-4 py-1',
  spacious: 'px-4 py-6',
};

type SignupStepLayoutProps = {
  children: React.ReactNode;
  footer?: {
    onSwitchToLogin?: () => void;
    showTermsAndConditions?: boolean;
    termsChecked?: boolean;
    onTermsChange?: (checked: boolean) => void;
  };
  actions?: {
    primaryLabel: string;
    onPrimaryClick: () => void;
    onBack?: () => void;
    primaryDisabled?: boolean;
    primaryLoading?: boolean;
    backDisabled?: boolean;
  };
  contentVariant?: ContentVariant;
};

export const SignupStepLayout: React.FC<SignupStepLayoutProps> = ({
  children,
  footer,
  actions,
  contentVariant = 'default',
}) => {
  return (
    <div className="w-full h-full pt-6 pb-2 flex flex-col items-center overflow-y-auto overflow-x-hidden [scrollbar-gutter:stable]">
      <div
        className={clsx(
          'self-stretch flex flex-col justify-start items-center gap-2.5',
          contentVariantStyles[contentVariant]
        )}
      >
        {children}
      </div>

      {/*Need to change this to include shrink inside the signupstepfooter */}
      {footer && (
        <div className="shrink-0">
          <SignupStepFooter
            onSwitchToLogin={footer.onSwitchToLogin}
            showTermsAndConditions={footer.showTermsAndConditions}
            termsChecked={footer.termsChecked}
            onTermsChange={footer.onTermsChange}
          />
        </div>
      )}

      {actions && (
        <div className="flex flex-col items-center justify-center shrink-0 pb-6">
          <SignupStepActions
            primaryLabel={actions.primaryLabel}
            onPrimaryClick={actions.onPrimaryClick}
            onBack={actions.onBack}
            primaryDisabled={actions.primaryDisabled}
            primaryLoading={actions.primaryLoading}
            backDisabled={actions.backDisabled}
          />
        </div>
      )}
    </div>
  );
};
